"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _helpers = require("../../utils/helpers");

var _Icon = require("./Icon.style");

var Icon = function Icon(_ref) {
  var name = _ref.name,
      color = _ref.color,
      size = _ref.size,
      spaceAround = _ref.spaceAround,
      minWidth = _ref.minWidth,
      rest = _objectWithoutProperties(_ref, ["name", "color", "size", "spaceAround", "minWidth"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      icons = _ref2.icons;

  var icon = name && (0, _helpers.getIcon)(name);
  var IconComponent = icon && icon.name;
  var iconProps = icon && icon.props || {};
  var strokeProps = {
    width: icons.width,
    lineCap: icons.lineCap,
    lineJoin: icons.lineJoin
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, IconComponent && /*#__PURE__*/_react.default.createElement(_Icon.IconWrapper, Object.assign({
    height: size,
    spaceAround: spaceAround,
    minWidth: minWidth,
    width: size
  }, iconProps, rest), /*#__PURE__*/_react.default.createElement(IconComponent, Object.assign({
    color: color
  }, strokeProps))));
};

Icon.propTypes = {
  name: _propTypes.default.string.isRequired,
  color: _propTypes.default.string,
  size: _propTypes.default.string,
  spaceAround: _propTypes.default.bool,
  minWidth: _propTypes.default.string
};
Icon.defaultProps = {
  color: '#000',
  size: '36px',
  spaceAround: true,
  minWidth: ''
};
var _default = Icon;
exports.default = _default;